module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Assignment & Vehicle Movement Tracking")]), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "ml-auto"
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('date-range-picker', {
    staticClass: "mr-2",
    attrs: {
      "opens": _vm.openLeft,
      "always-show-calendars": _vm.showCal,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Assignment No. / Client Name / Container No. /Vehicle No /GRN No./Booking No."
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.dateStatusList,
      "option-value": "inv",
      "option-text": "int",
      "placeholder": "Select Date Filter"
    },
    on: {
      "input": function($event) {
        _vm.viewAssignment('0', '1', '1')
      }
    },
    model: {
      value: (_vm.dateStatusFilter),
      callback: function($$v) {
        _vm.dateStatusFilter = $$v
      },
      expression: "dateStatusFilter"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Vehicle Status")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.VehicleStatusList,
      "option-value": "val",
      "option-text": "status",
      "placeholder": "Select Vehicle Status"
    },
    on: {
      "input": function($event) {
        _vm.viewAssignment('0', '1', '1')
      }
    },
    model: {
      value: (_vm.vehicleStatusFilter),
      callback: function($$v) {
        _vm.vehicleStatusFilter = $$v
      },
      expression: "vehicleStatusFilter"
    }
  })], 1)], 1), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "text-muted pull-right mt-2"
  }, [_c('small', [_vm._v(_vm._s(_vm.totalRows) + " Entries")])])]), _vm._v(" "), _c('b-row', [_c('b-col', [(_vm.dateRange.endDate != '' && _vm.dateRange.startDate != '') ? _c('b-button', {
    staticClass: "pull-right ml-1 mt-1",
    attrs: {
      "disabled": _vm.ExcelBtnName != 'Export As Excel' ? true : false,
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.getReports('GPS_GRN_LIST_EXCEL')
      }
    }
  }, [_vm._v(_vm._s(_vm.ExcelBtnName) + "\n            "), (_vm.ExcelBtnName != 'Export As Excel') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('b-col', [(_vm.veiwVehicleBookingForm.length > 0) ? _c('b-button', {
    staticClass: "pull-right ml-1 mt-1",
    attrs: {
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": _vm.exportToExcelClient
    }
  }, [_vm._v("\n            Export (Client XLSX)\n          ")]) : _vm._e(), _vm._v(" "), (_vm.veiwVehicleBookingForm.length > 0) ? _c('b-button', {
    staticClass: "pull-right ml-1 mt-1",
    attrs: {
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": _vm.exportOfBuyingRateToExcelClient
    }
  }, [_vm._v("\n            OF Rate Export (Client XLSX)\n          ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tableMain mt-2"
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.veiwVehicleBookingForm,
      "fields": _vm.fields,
      "per-page": _vm.perPage,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "quotationId",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage))])]
      }
    }, {
      key: "salesSeries",
      fn: function(row1) {
        return [_c('b', {
          staticClass: "showMoreData",
          on: {
            "click": function($event) {
              _vm.viewAssignmentpage(
                row1.item.clientId,
                row1.item.salesBookingId,
                row1.item.quotationId,
                row1.item.assignId
              )
            }
          }
        }, [_vm._v("\n              Assignment No. : " + _vm._s(row1.item.assignSeries.split(",")[0]) + "\n              "), _c('br')]), _vm._v(" "), _c('span', [_vm._v("Execution No. : " + _vm._s(row1.item.salesSeries))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', [_c('b-button', {
          attrs: {
            "variant": "outline-success",
            "size": "sm"
          },
          on: {
            "click": function($event) {
              _vm.goToTrack(row1.item.assignId)
            }
          }
        }, [_vm._v("Track Assignment")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "outline-dark"
          },
          on: {
            "click": function($event) {
              _vm.showDocModal(row1.item)
            }
          }
        }, [_vm._v("Summary & Documents")]), _vm._v(" "), _c('Assignment-Summary', {
          attrs: {
            "title": 'Shipment Summary Tracking - ',
            "fk_all_module_id": row1.item.allModuleId,
            "jb_series": row1.item.salesSeries
          }
        }), _vm._v(" "), (row1.item.allModuleId) ? _c('ContainerSummary', {
          attrs: {
            "PMC_title": 'Container Summary Job No - ' + row1.item.salesSeries,
            "PMC_JOBID": row1.item.allModuleId,
            "PMC_JOBNO": row1.item.salesSeries,
            "PMC_JOBDATE": '',
            "PMC_JOBTYPE": '',
            "PMC_AgentType": '',
            "PMC_Client": '',
            "PMC_Sline": ''
          }
        }) : _vm._e(), _vm._v(" "), _c('Assignment-Summary', {
          attrs: {
            "title": 'Shipment Summary Tracking - ',
            "fk_all_module_id": row1.item.allModuleId,
            "jb_series": row1.item.salesSeries
          }
        }), _vm._v(" "), _c('MSDeleteRequest', {
          attrs: {
            "item": row1.item,
            "JobNo": row1.item.salesSeries,
            "JobID": row1.item.allModuleId,
            "sessionsStorage": _vm.$sessionsStorage
          },
          on: {
            "refreshData": _vm.handleRefresh
          }
        }), _vm._v(" "), (row1.item.deleteRequestBy != '' && row1.item.deleteRequestBy != '0' && row1.item.deleteRequestBy != null) ? _c('b', [_vm._v("Requested By : " + _vm._s(row1.item.deleteRequestBy)), _c('br')]) : _vm._e(), _vm._v(" "), (row1.item.deleteArrovedBy != '' && row1.item.deleteArrovedBy != '0' && row1.item.deleteArrovedBy != null) ? _c('b', [_vm._v("Arroved By : " + _vm._s(row1.item.deleteArrovedBy)), _c('br')]) : _vm._e()]
      }
    }, {
      key: "ContainerNo",
      fn: function(row3) {
        return [(row3.item.ContainerNo != null) ? _c('div', _vm._l((row3.item.ContainerNo.split(',')), function(item, index) {
          return _c('span', {
            key: index
          }, [_c('h6', [_c('b-badge', {
            attrs: {
              "variant": "light"
            }
          }, [_vm._v(_vm._s(item + " "))])], 1)])
        })) : _vm._e()]
      }
    }, {
      key: "vehicleNO",
      fn: function(row2) {
        return [_c('span', [_vm._v("Vehicle Required : " + _vm._s(row2.item.noOfTrucks))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Booked Vehicle : " + _vm._s(row2.item.vehicleNO))])]
      }
    }, {
      key: "GRNCount",
      fn: function(row5) {
        return [_c('span', [_vm._v("\n              " + _vm._s(row5.item.GRNCount) + "\n              "), _c('br')]), _vm._v(" "), _c('span', [_vm._v("\n              " + _vm._s(row5.item.GRNSeries) + "\n              "), _c('br')]), _vm._v(" "), _c('Add-Message', {
          staticStyle: {
            "list-style-type": "none"
          },
          attrs: {
            "fk_all_module_id": row5.item.allModuleId,
            "fk_client_id": row5.item.clientId,
            "fk_pod_id": row5.item.PODLocationId
          }
        })]
      }
    }])
  })], 1), _vm._v(" "), _c('div', [_c('h5', [_c('b-pagination', {
    attrs: {
      "limit": "5",
      "align": "center",
      "per-page": _vm.perPage,
      "total-rows": _vm.totalRows
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)])], 1)], 1), _vm._v(" "), _c('div', [_c('b-modal', {
    ref: "doc-modal",
    staticClass: "modal-dialog-doc",
    attrs: {
      "size": "xl",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": "",
      "title": 'Assignment Summary & Documents - ' + _vm.JOBSERIES
    }
  }, [(_vm.ALLMODULE) ? _c('div', [_c('doc-form', {
    attrs: {
      "allModuleIdProp": _vm.ALLMODULE,
      "JOBSERIES": _vm.JOBSERIES
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "outline-danger",
      "block": ""
    },
    on: {
      "click": _vm.hideDocModal
    }
  }, [_vm._v("Close\n      ")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cb54d664","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/view/listView/viewSalesBooking.vue
// module id = 2862
// module chunks = 0